/**
 * @see https://oss.navercorp.com/place/federated-bff-gateway-support/issues/27
 * 로그인/미로그인 여부에 따라 노출되는 카드를 순서대로 내려줍니다.
 */
import { gql } from '@web/federation/gql'

export const MySectionsQuery = gql(`
  query MySections {
    ...MySections_Query
  }

  fragment MySections_Query on Query {
    mySections {
      ... on MySectionsSucceed {
        __typename
        sections {
          __typename
          id
          title
          type
          ... on DDayRecommendationSection {
            description
          }
          ... on MissionSection {
            missionPageUrl {
              webUrl
              appScheme
            } 
          }
          ... on MissionSection {
            description
            missionPageUrl{
              webUrl
              appScheme
            }
          }
          ... on MyReviewImpactSection {
            reviewTabPageUrl {
              webUrl
              appScheme
            }
          }
          ... on ProfileSection {
            profileSettingUrl{
              webUrl
              appScheme
            }
            reviewPageUrl{
              webUrl
              appScheme
            }
          }
          ... on TimelineSection {
            checkinPageUrl {
              webUrl
              appScheme
            }
            timelinesPageUrl {
              webUrl
              appScheme
            }
          }
          ... on UnwrittenReviewSection {
            checkinPageUrl {
              webUrl
              appScheme
            }
          }
          ... on SeatAlertSection {
            description
          }
          ... on ShortcutSection {
            reviewPageUrl{
              webUrl
              appScheme
            }
            bookmarkPageLandingUrl {
              webUrl
              appScheme
            }
            couponPageUrl {
              webUrl
              appScheme
            }
          }
          ...on FrequentPlaceSection {
            title
            type
            myHomeListLandingUrl {
              appScheme
              webUrl
            }
            myHomeEditLandingUrl {
              appScheme
              webUrl
            }
            myWorkplaceEditLandingUrl {
              appScheme
              webUrl
            }
            frequentPlaceListLandingUrl {
              appScheme
              webUrl
            }
          }
          ...on RecentPlaceBookmarkSection {
            title
            type
            bookmarkPageLandingUrl {
              appScheme
              webUrl
            }
          }
          ...on MYDrivingSection {
            type
            title
            carSettingLandingUrl {
              appScheme
              webUrl
            }
            drivingHistoryLandingUrl {
              appScheme
              webUrl
            }
            drivingAnalysisLandingUrl {
              appScheme
              webUrl
            }
            insuranceInfo {
              landingUrl {
                webUrl
                appScheme
              }
              tooltipMessage
              tooltipVersion
            }
          }
        }
        isLogin
      }
    }
  }
`)
